var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin"},[_c('div',{staticClass:"hero is-primary"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title is-size-1"},[_vm._v("Admin")])])])]),_c('div',{staticClass:"container"},[_c('br'),_c('br'),_c('br')])])
}]

export { render, staticRenderFns }